import {
  AGENDAS_FETCH_REQUEST,
  AGENDAS_FETCH_SUCCESS,
  AGENDAS_FETCH_FAILURE,
  AGENDAS_CREATE_REQUEST,
  AGENDAS_CREATE_SUCCESS,
  AGENDAS_CREATE_FAILURE,
  AGENDAS_UPDATE_REQUEST,
  AGENDAS_UPDATE_SUCCESS,
  AGENDAS_UPDATE_FAILURE,
  AGENDAS_DELETE_REQUEST,
  AGENDAS_DELETE_SUCCESS,
  AGENDAS_DELETE_FAILURE,
  AGENDAS_SET_LOADING,
  AGENDAS_SET_ERROR,
  AGENDAS_CLEAR_ERROR
} from './agendasTypes.js';

import { mockAgendas } from '../../../data/mockData.js';

const mockDelay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const fetchAgendasRequest = () => ({
  type: AGENDAS_FETCH_REQUEST
});

export const fetchAgendasSuccess = (agendas) => ({
  type: AGENDAS_FETCH_SUCCESS,
  payload: agendas
});

export const fetchAgendasFailure = (error) => ({
  type: AGENDAS_FETCH_FAILURE,
  payload: error
});

export const createAgendaRequest = () => ({
  type: AGENDAS_CREATE_REQUEST
});

export const createAgendaSuccess = (agenda) => ({
  type: AGENDAS_CREATE_SUCCESS,
  payload: agenda
});

export const createAgendaFailure = (error) => ({
  type: AGENDAS_CREATE_FAILURE,
  payload: error
});

export const updateAgendaRequest = () => ({
  type: AGENDAS_UPDATE_REQUEST
});

export const updateAgendaSuccess = (agenda) => ({
  type: AGENDAS_UPDATE_SUCCESS,
  payload: agenda
});

export const updateAgendaFailure = (error) => ({
  type: AGENDAS_UPDATE_FAILURE,
  payload: error
});

export const deleteAgendaRequest = () => ({
  type: AGENDAS_DELETE_REQUEST
});

export const deleteAgendaSuccess = (agendaId) => ({
  type: AGENDAS_DELETE_SUCCESS,
  payload: agendaId
});

export const deleteAgendaFailure = (error) => ({
  type: AGENDAS_DELETE_FAILURE,
  payload: error
});

export const setLoading = (loading) => ({
  type: AGENDAS_SET_LOADING,
  payload: loading
});

export const setError = (error) => ({
  type: AGENDAS_SET_ERROR,
  payload: error
});

export const clearError = () => ({
  type: AGENDAS_CLEAR_ERROR
});

export const fetchAgendas = () => async (dispatch, getState) => {
  dispatch(fetchAgendasRequest());
  
  try {
    await mockDelay(500);
    
    const { auth } = getState();
    let agendas = mockAgendas;
    
    // Filter agendas based on user role
    if (auth.role === 'Client') {
      agendas = agendas.filter(agenda => agenda.visibility === 'public');
    } else if (auth.role === 'Advisor') {
      agendas = agendas.filter(agenda => 
        agenda.ownerId === auth.user.id || agenda.visibility === 'public'
      );
    }
    
    dispatch(fetchAgendasSuccess(agendas));
  } catch (error) {
    dispatch(fetchAgendasFailure(error.message));
  }
};

export const createAgenda = (agendaData) => async (dispatch) => {
  dispatch(createAgendaRequest());
  
  try {
    await mockDelay(800);
    
    const newAgenda = {
      ...agendaData,
      id: Date.now().toString(),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    
    dispatch(createAgendaSuccess(newAgenda));
  } catch (error) {
    dispatch(createAgendaFailure(error.message));
  }
};

export const updateAgenda = (agendaId, updates) => async (dispatch) => {
  dispatch(updateAgendaRequest());
  
  try {
    await mockDelay(600);
    
    const updatedAgenda = {
      ...updates,
      id: agendaId,
      updatedAt: new Date().toISOString()
    };
    
    dispatch(updateAgendaSuccess(updatedAgenda));
  } catch (error) {
    dispatch(updateAgendaFailure(error.message));
  }
};

export const deleteAgenda = (agendaId) => async (dispatch) => {
  dispatch(deleteAgendaRequest());
  
  try {
    await mockDelay(400);
    dispatch(deleteAgendaSuccess(agendaId));
  } catch (error) {
    dispatch(deleteAgendaFailure(error.message));
  }
};